/**
 * @generated SignedSource<<11ac3f62599360ebf7b034845128010e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompetitionDeleteButtonMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type CompetitionDeleteButtonMutation$data = {
  readonly deleteCompetition: string;
};
export type CompetitionDeleteButtonMutation = {
  response: CompetitionDeleteButtonMutation$data;
  variables: CompetitionDeleteButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "deleteCompetition",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionDeleteButtonMutation",
    "selections": [
      (v3/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionDeleteButtonMutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteCompetition",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "394d0ab389fc35b33ecda5322522940e",
    "id": null,
    "metadata": {},
    "name": "CompetitionDeleteButtonMutation",
    "operationKind": "mutation",
    "text": "mutation CompetitionDeleteButtonMutation(\n  $id: ID!\n) {\n  deleteCompetition(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "02babe1cca813c122d5059882b39ad39";

export default node;
